import { PeriodOption } from './chartShared';
import { ProfitabilityPeriodKey } from './types';

export const PROFITABILITY_PERIOD_OPTIONS: PeriodOption[] = [
  { value: 'accumulated', label: 'Ótimo' },
  { value: '3_months', label: '3 meses' },
  { value: '6_months', label: '6 meses' },
  { value: '12_months', label: '12 meses' },
];

export const PROFITABILITY_HISTORY_PERIODS: {
  label: string;
  key: ProfitabilityPeriodKey;
}[] = [
  { label: 'No mês', key: 'month' },
  { label: '3 meses', key: '3_months' },
  { label: '6 meses', key: '6_months' },
  { label: '12 meses', key: '12_months' },
  { label: 'No ano', key: 'year' },
  { label: 'Acumulado', key: 'accumulated' },
];

export const CDI_COLOR = '#6D6E71';

export const monthlyCdiHelp =
  'Mostra a rentabilidade mensal de cada cota como percentual do CDI no mesmo mês. Valores acima de 100% indicam desempenho superior ao CDI mensal.';

export const pddOverAtrasoHelp =
  'Relação entre PDD e valor em atraso. Ajuda a avaliar quanto do atraso já está provisionado nos informes disponíveis.';

export const creditRightsOverPlHelp =
  'Relação entre direitos creditórios e patrimônio líquido. Ajuda a acompanhar o enquadramento regulatório e o grau de alavancagem do fundo.';
